import aesjs from "aes-js"

const ENCRYPTION_KEY_STRING = process.env.GATSBY_NEW_API_APPLICATION_ID || ""

export function encryptText(text: string): string {
  try {
    const textBytes = aesjs.utils.utf8.toBytes(text)
    const keyBytes = aesjs.utils.utf8.toBytes(
      ENCRYPTION_KEY_STRING.padEnd(32).slice(0, 32)
    )

    const aesCtr = new aesjs.ModeOfOperation.ctr(keyBytes, new aesjs.Counter(5))
    const encryptedBytes = aesCtr.encrypt(textBytes)

    return aesjs.utils.hex.fromBytes(encryptedBytes)
  } catch (e) {
    console.error("Encryption failed:", e)
    return ""
  }
}

export function decryptText(hexCiphertext: string): string {
  try {
    const encryptedBytes = aesjs.utils.hex.toBytes(hexCiphertext)
    const keyBytes = aesjs.utils.utf8.toBytes(
      ENCRYPTION_KEY_STRING.padEnd(32).slice(0, 32)
    )

    const aesCtr = new aesjs.ModeOfOperation.ctr(keyBytes, new aesjs.Counter(5))
    const decryptedBytes = aesCtr.decrypt(encryptedBytes)

    return aesjs.utils.utf8.fromBytes(decryptedBytes)
  } catch (e) {
    console.error("Decryption failed:", e)
    return ""
  }
}
